export default __webpack_public_path__ + "static/media/abo.337e6a37.JPG";